import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import axios from "axios";

import swal from "sweetalert";

import Spinner from'../../spinners/DataSpinner';

const ViewCategories = () => {
    const [loading, setLoading] = useState(true);
    const [categoryList, setCategoryList] = useState([]);

    useEffect(() => {
        axios.post(`api/view-categories`)
            .then(res => {
                if (res.data.status === 200) {
                    setCategoryList(res.data.categories);
                };
                setLoading(false);
            });
    }, []);

    const deleteCategory = (e, id) => {
        e.preventDefault();

        const thisClicked = e.currentTarget;
        thisClicked.innerText = "Deleting...";

        axios.delete(`api/delete-category/${id}`)
            .then(res => {
                if (res.data.status === 200) {
                    swal('Success', res.data.message, 'success');
                    thisClicked.closest("tr").remove();
                } else if (res.data.status === 404) {
                    swal('Error', res.data.message, 'error');
                    thisClicked.innerText = "Deleting";
                }
            });
    }

    let dataTableData = '';
    if (loading) {
        return <Spinner/>
    } else {
        dataTableData =
            categoryList.map((item) => {
                return (
                    <tr key={item.id}>
                        <td>{item.id}</td>
                        <td>{item.name}</td>
                        <td>{item.slug}</td>
                        <td>{item.status}</td>
                        <td>
                            <Link to={`/admin/edit-category/${item.id}`} className="btn btn-success btn-sm">Edit</Link>
                        </td>
                        <td>
                            <button type="button" onClick={(e) => deleteCategory(e, item.id)} className="btn btn-danger btn-sm">Delete</button>
                        </td>
                    </tr>
                );
            });
    }

    return (
        <div className="card shadow mb-4">
            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                <h3 className="h5 mb-0 text-gray-800">View Categories</h3>
                <Link to="/admin/add-category" className="btn btn-primary btn-md">Add Category</Link>
            </div>
            <div className="card-body">
                <table className="table">
                    <thead>
                        <tr>
                            <th scope="col">ID</th>
                            <th scope="col">Name</th>
                            <th scope="col">Slug</th>
                            <th scope="col">Status</th>
                            <th scope="col">Edit</th>
                            <th scope="col">Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dataTableData}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default ViewCategories;